import { render, staticRenderFns } from "./Div.vue?vue&type=template&id=6d3b34f5&"
import script from "./Div.vue?vue&type=script&lang=ts&"
export * from "./Div.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports